import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  IconButton,
  Chip
} from '@mui/material';
import {
  DirectionsCar as CarIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import { ZulassungsantragResponse } from '../../types/antrag';

interface FahrzeugdatenCardProps {
  antrag: ZulassungsantragResponse;
  onEdit: () => void;
  evbNummer?: string;
}

const FahrzeugdatenCard: React.FC<FahrzeugdatenCardProps> = ({
  antrag,
  onEdit,
  evbNummer
}) => {
  return (
    <Card elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<CarIcon />}
        title="Fahrzeugdaten"
        subheader="Technische Daten des Fahrzeugs"
        action={
          <IconButton 
            onClick={onEdit}
            size="small"
            color="primary"
          >
            <EditIcon />
          </IconButton>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" color="textSecondary">
              FIN:
            </Typography>
            <Typography variant="body1" fontWeight="bold">
              {antrag.fahrzeug?.fin || antrag.fin || 'Nicht verfügbar'}
            </Typography>
          </Grid>

          {antrag.fahrzeug?.kraftstoffart?.toLowerCase() === 'elektro' && (
            <Grid item xs={12}>
              <Chip
                label="Elektrofahrzeug"
                color="success"
                size="small"
                variant="outlined"
              />
            </Grid>
          )}

          {/*
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Hersteller:
            </Typography>
            <Typography variant="body1">
              {antrag.fahrzeug?.hersteller || 'Nicht verfügbar'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Modell:
            </Typography>
            <Typography variant="body1">
              {antrag.fahrzeug?.modell || 'Nicht verfügbar'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Marke:
            </Typography>
            <Typography variant="body1">
              {antrag.fahrzeug?.marke || 'Nicht verfügbar'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="textSecondary">
              Kennzeichentyp:
            </Typography>
            <Typography variant="body1">
              {antrag.fahrzeug?.kennzeichenTyp || 'Nicht verfügbar'}
            </Typography>
          </Grid>
          {antrag.fahrzeug?.saisonVon && antrag.fahrzeug?.saisonBis && (
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                Saison:
              </Typography>
              <Typography variant="body1">
                Monat {antrag.fahrzeug.saisonVon} bis {antrag.fahrzeug.saisonBis}
              </Typography>
            </Grid>
          )}
          {antrag.fahrzeug?.hsn && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                HSN:
              </Typography>
              <Typography variant="body1">
                {antrag.fahrzeug.hsn}
              </Typography>
            </Grid>
          )}
          {antrag.fahrzeug?.tsn && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                TSN:
              </Typography>
              <Typography variant="body1">
                {antrag.fahrzeug.tsn}
              </Typography>
            </Grid>
          )}
            */}
          {antrag.fahrzeug?.zb1Nummer && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                ZB1 Nummer:
              </Typography>
              <Typography variant="body1">
                {antrag.fahrzeug.zb1Nummer}
              </Typography>
            </Grid>
          )}
          
          {antrag.fahrzeug?.zb1Sicherheitscode && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                ZB1 Sicherheitscode:
              </Typography>
              <Typography variant="body1">
                {antrag.fahrzeug.zb1Sicherheitscode}
              </Typography>
            </Grid>
          )}
          {antrag.fahrzeug?.zb2Nummer && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                ZB2 Nummer:
              </Typography>
              <Typography variant="body1">
                {antrag.fahrzeug.zb2Nummer}
              </Typography>
            </Grid>
          )}
          {antrag.fahrzeug?.zb2Sicherheitscode && (
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                ZB2 Sicherheitscode:
              </Typography>
              <Typography variant="body1">
                {antrag.fahrzeug.zb2Sicherheitscode}
              </Typography>
            </Grid>
          )}
          {evbNummer && (
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary">
                eVB-Nummer:
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {evbNummer}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FahrzeugdatenCard;
